import { useTranslation } from "react-i18next";

const ContractHeader = ({ onSort, sortByField, orderSortByField }) => {
  const { t } = useTranslation();

  const handleSort = (field) => {
    if (!onSort) return;
    if (sortByField === field) {
      onSort(field, orderSortByField === "1" ? "-1" : "1");
    } else {
      onSort(field, "1");
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    return "fa-sort";
  };

  return (
    <article className="table-standard-header">
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("contract_number")}
      >
        {t("settingsContacts.referenceColumn")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("contract_number")}`} />
        </span>
      </div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("collector")}
      >
        {t("Collector name")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("collector")}`} />
        </span>
      </div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("collectorEmail")}
      >
        {t("settingsContacts.planningEmailColumn")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("collectorEmail")}`} />
        </span>
      </div>
      <article className="table-standard-header-cell" />
    </article>
  );
};

export default ContractHeader;
